<template>
  <v-app-bar id="core-toolbar" app clipped-left color="secondary">
    <div class="v-toolbar-title">
      <v-toolbar-title class="font-weight-light">
        <v-btn v-if="responsive" class="v-btn" dark icon @click.stop="onClickBtn">
          <v-icon>mdi-view-list</v-icon>
        </v-btn>
        <v-btn v-if="!responsive" class="v-btn" dark icon>
          <v-icon v-if="mini" @click="setMini">mdi-format-align-center</v-icon>
          <v-icon v-if="!mini" @click="setMini">mdi-format-list-bulleted-square</v-icon>
        </v-btn>
      </v-toolbar-title>
    </div>

    <v-breadcrumbs :items="breadcrumbs" dark>
      <template v-slot:item="props">
        <div v-ripple class="breadcrumbs-item" @click.prevent="redirect(props.item.href)">
          <a href>{{ props.item.text.toUpperCase() }}</a>
        </div>
      </template>
    </v-breadcrumbs>
    <v-spacer />
    <Search/>
    <v-spacer />
    <v-toolbar-items>
      <v-flex align-center layout py-2>
        <div v-ripple class="toolbar-items">
          <v-icon color="white" @click="goBack()">mdi-undo</v-icon>
        </div>
        <v-dialog v-model="inviteDialog" scrollable max-width="500px">
          <template v-slot:activator="{ on }">
            <div v-ripple class="toolbar-items">
              <v-icon color="white" v-on="on">mdi-account-clock</v-icon>
            </div>
          </template>
          <v-card>
            <v-card-title>Pending Invites</v-card-title>
            <v-divider></v-divider>
            <v-card-text style="height: 300px;">
              <v-list two-line>
                <template v-for="(invite, index) in invites">
                  <v-list-item :key="invite.inviteId">
                    <v-list-item-content>
                      <v-list-item-title>{{ invite.email }}</v-list-item-title>
                      <v-list-item-subtitle class="text--primary">{{ invite.org.name }}</v-list-item-subtitle>
                      <v-list-item-subtitle>invite send on {{ invite.createdOn }}</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-list-item-action-text>{{ invite.role.name }}</v-list-item-action-text>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn icon color="red" v-on="on" @click="cancel(invite.inviteId)">
                            <v-icon>mdi-cancel</v-icon>
                          </v-btn>
                        </template>
                        <span>Cancel</span>
                      </v-tooltip>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider v-if="index + 1 < invites.length" :key="index"></v-divider>
                </template>
              </v-list>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="blue darken-1" text @click="inviteDialog = false">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- <v-menu bottom left content-class="dropdown-menu" offset-y transition="slide-y-transition">
          <template v-slot:activator="{ on }">
            <div v-ripple class="toolbar-items" v-on="on">
              <v-badge color="error" overlap>
                <template slot="badge">{{ notifications.length }}</template>
                <v-icon color="white">mdi-bell</v-icon>
              </v-badge>
            </div>
          </template>
          <v-card>
            <v-list dense>
              <v-list-item v-for="notification in notifications" :key="notification" @click="onClick">
                <v-list-item-title v-text="notification" />
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu> -->
        <v-menu bottom left content-class="dropdown-menu" offset-y transition="slide-y-transition">
          <template v-slot:activator="{ on }">
            <div v-ripple class="toolbar-items" v-on="on">
              <v-icon color="white">mdi-dots-vertical</v-icon>
            </div>
          </template>
          <v-card>
            <v-list dense>
              <v-list-item v-for="item in items" :key="item.title" @click="onOption(item.title)">
                <v-list-item-title v-text="item.title" />
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
      </v-flex>
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
import { mapMutations, mapState } from "vuex"
import {
  GetOrg,
  // GetInvitesCreatedByUser,
  DeletePendingInviteByID,
} from "@/services/API.js"
import Search from '../globalSearch/Search.vue'
import { AmplifyEventBus } from "aws-amplify-vue"
import { Logger, Cache } from "aws-amplify"
import Auth from "@/services/Auth.js"

const logger = new Logger("Toolbar")
export default {
  components: {
    Search
  },
  data: () => ({
    notifications: [
      "Mike, John responded to your email",
      "You have 5 new tasks",
      "You're now a friend with Andrew",
      "Another Notification",
      "Another One",
    ],
    items: [{ title: "Account" }, { title: "Logout" }],
    home: [{ text: "admin", href: "/dashboard" }],
    invites: [],
    inviteDialog: false,
    responsive: false,
    responsiveInput: false,
  }),

  computed: {
    ...mapState("app", ["mini"]),
    ...mapState(["goToken"]),
    ...mapState('permissions', ['ignore', 'userPermissions']),
    breadcrumbs: {
      get() {
        return this.$store.state.app.breadcrumbs
      },
      set(val) {
        this.$store.commit("app/setBreadcrumbs", val)
      },
    },
  },

  watch: {
    $route(newVal, oldVal) {
      logger.info("Breadcrumbs: ", newVal, oldVal)
      if (newVal.path.includes("organisation")) {
        const orgId = newVal.params.name
        this.setOrgDetail(orgId)
      } else {
        this.breadcrumbs = this.home.concat(
          newVal.matched.map((route) => {
            return {
              text: route.name,
              href: route.path,
            }
          })
        )
      }
      logger.info(this.breadcrumbs)
    },
  },

  created() {
    this.breadcrumbs = this.home
    // const user = await this.$Amplify.Auth.currentAuthenticatedUser();
    // const res = await GetInvitesCreatedByUser(
    // 	"Provision Cameramatics",
    // 	user.attributes.email
    // );
    // if (res && res.Invites.length > 0) {
    // 	this.invites = res.Invites.filter(invite => {
    // 		return invite.expired === "false";
    // 	});
    // }
  },

  mounted() {
    this.onResponsiveInverted()
    window.addEventListener("resize", this.onResponsiveInverted)
    logger.info(this.$route)
    this.title = this.$route.name
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted)
  },

  methods: {
    ...mapMutations("app", ["setDrawer", "toggleDrawer", "toggleMini"]),
    ...mapMutations('permissions', ['setIgnore']),
    togglePermissions () {
      logger.debug("permissions", this.userPermissions)
      this.setIgnore()
    },
    async setOrgDetail(id) {
      const org = await GetOrg(id)
      logger.warn(this.$route.matched)
      this.breadcrumbs = this.home.concat(
        this.$route.matched.map((route, index) => {
          if (index === 0) {
            return {
              text: org.name,
              href: route.path.replace(":name", id),
            }
          }
          return {
            text: route.name,
            href: route.path.replace(":name", id),
          }
        })
      )
    },
    onClickBtn() {
      this.setDrawer(!this.$store.state.app.drawer)
    },
    onClick() {},
    setMini() {
      this.toggleMini()
    },
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true
        this.responsiveInput = false
      } else {
        this.responsive = false
        this.responsiveInput = true
      }
    },
    async cancel(id) {
      const res = await DeletePendingInviteByID(id)
      if (res) {
        this.invites = this.invites.filter((invite) => {
          return invite.id === id
        })
        AmplifyEventBus.$emit("snackEvent", {
          color: "success",
          text: `invite canceled`,
        })
      }
    },
    onOption(option) {
      logger.info(option)

      switch (option) {
        case "Account":
          this.$router.push({ path: "/user-profile" })
          break
        case "Logout":
          confirm("You are going to sign out.") && this.logout()
          break
        default:
          break
      }
    },
    redirect(link) {
      logger.info(link)
      this.$router.push({ path: link })
    },
    goBack() {
      this.$router.go(-1)
    },
    logout() {
      Auth.SignOut()
        .then((res) => {
          window.name = JSON.stringify({ signedOut: true })
          logger.debug("signing out", res)
          AmplifyEventBus.$emit("authState", "signedOut")
          Cache.clear();
          this.$session.clear();
          if(this.goToken) {
            location.replace(location.protocol + "//" + process.env.VUE_APP_go_auth_domain)
          } else {
            location.replace(location.protocol + "//" + process.env.VUE_APP_auth_domain)
          }
          // this.$router.replace({ path: "/auth" });
        })
        .catch((err) => {
          logger.error(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#core-toolbar a {
  text-decoration: none;
}

.toolbar-items {
  cursor: pointer;
}

.v-toolbar-title {
  margin-left: -8px;
}

.v-breadcrumbs {
  .breadcrumbs-item {
    padding: 5px;
  }
  a {
    color: #ffffff;
  }
}
</style>
